import { EventEmitter } from 'events';

/*
for ruleParser
ruleHide: {
                conditions: {
                    any: [{
                        all: [{
                            fact: 'id',
                            operator: 'equal',
                            value: 18742
                        }, {
                            fact: 'cd_key',
                            operator: 'equal',
                            value: -999
                        }]
                    }
                    ]
                },
                event: {
                    type: 'hide',
                    params: {
                        id: 18752 + "-" + 4,
                        property: 'display',
                        property_value: 'none'
                    }
                }
            },
*/
const reducerAnd = (accumulator, currentValue, idx) => {
    return accumulator && currentValue
};

const reducerOr = (accumulator, currentValue, idx) => {
    return accumulator || currentValue
};

//const mapper = (obj) => {
function mapper (obj) {
    if (obj.any) {
        return obj.any.map(mapper, { param: this.param }).reduce(reducerOr)
    } else if (obj.all) {
        return obj.all.map(mapper, { param: this.param }).reduce(reducerAnd)
    } else {
        if(obj.operator === "equal") {
            return obj.value == this.param[obj.fact]
        } else if(obj.operator === "notEqual") {
            return obj.value != this.param[obj.fact]
        }
    }
}

/**
 * equal
 * notEqual
 * these operators use strict equality (=== ??? ) and inequality (!== ???)
 *
 * in - fact must be included in value (an array)
 * notIn - fact must not be included in value (an array)
 * contains - fact (an array) must include value
 * doesNotContain - fact (an array) must not include value
 *
 */

export class RuleParser extends EventEmitter {
    constructor() {
        super();
    }

    /* For RuleHide above not used */
    ruleParser (ruleHide, param) {
        if (ruleHide.conditions.any) {
            let result = ruleHide.conditions.any.map(mapper, { param: param }).reduce(reducerOr),
            event = ruleHide.event
            this.emit('input', { result, event })
            return result
        } else if (ruleHide.conditions.all) {
            let result = ruleHide.conditions.all.map(mapper, { param: param }).reduce(reducerAnd),
            event = ruleHide.event
            this.emit('input', { result, event })
            return result
        }
    }

    ruleParserNew (ruleHide, param, cancel) {
        let result = ruleHide.cd_id === param.id
            let actions = ruleHide.actions
            for(var i = 0 ; actions && i < actions.length; i++) {
                let action = actions[i]
                if(action.ref_action == 'hide'){
                    if(cancel){
                        this.emit('show', { result, action })
                        // console.log('show ' + action.ref_id + ' ' + action.ref_table + ' ' + action.ref_action + ' ' + cancel)
                    } else {
                        this.emit('hide', { result, action })
                        // console.log('hide '+ action.ref_id + ' ' + action.ref_table + ' ' + action.ref_action  + ' ' + cancel)
                    }
                } else { // action show
                    if(cancel){
                        this.emit('hide', { result, action })
                        // console.log('hide ' + action.ref_id + ' ' + action.ref_table + ' ' + action.ref_action + ' ' + cancel)
                    } else {
                        this.emit('show', { result, action })
                        // console.log( 'show ' + action.ref_id + ' ' + action.ref_table + ' ' + action.ref_action + ' ' + cancel)
                    }
                }
            }
            return result
    }
}

